import { combineReducers, Reducer } from 'redux';
import { reducer as barcodeSearchReducer } from 'b2b-apps/shop/catalog/redux/barcodeSearch/reducer';
import { reducer as inkFinderReducer } from 'b2b-apps/shop/catalog/redux/inkFinder/reducer';
import { reducer as searchReducer } from 'b2b-apps/shop/catalog/redux/search/reducer';
import { reducer as skuListReducer } from 'b2b-apps/shop/catalog/redux/skuList/reducer';
import { reducer as suggestionsReducer } from 'b2b-apps/shop/catalog/redux/suggestions/reducer';
import { CatalogActions, CatalogState } from 'b2b-apps/shop/catalog/redux/types';

const reducer: Reducer<CatalogState, CatalogActions> = combineReducers({
  search: searchReducer,
  barcodeSearch: barcodeSearchReducer,
  inkFinder: inkFinderReducer,
  skuList: skuListReducer,
  suggestions: suggestionsReducer,
});

export { reducer };
